<template>
    <div class="article-container">
        <div class="main-article">
            <article3/>
        </div>
    </div>
</template>

<script>
    import article3 from '@/views/article/article3.vue'
    export default {
        name:'Adjust',
        components:{
            article3
        },
        data () {
            return {
                activePage:1,
                mediateContent:'',
                innerHeight:window.innerHeight,
                scrollBaseCount:1

            }
        },
        mounted() {
            this.init();
        },
        methods: {

            init(){
                // getCopyrightMedia().then(res=>{
                //     if(res.code==200){
                //         this.mediateContent = res.result.mediateContent;
                //     }   
                    
                // })
            },
            handlePagepre(){
                this.scrollBaseCount-=1;
                // this.$refs.contentRef.scroll(0,this.scrollBaseCount*100);
                this.$refs.contentRef.scroll(0,this.$refs.contentRef.scrollTop-400);
            },
            handlePageNext(){
                // this.$refs.contentRef.scroll(0,this.scrollBaseCount*100);
                this.$refs.contentRef.scroll(0,this.$refs.contentRef.scrollTop+400);
                this.scrollBaseCount+=1;
            },
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>
 
 .article-container{
    margin-top: 68px;
    background-color: #fff;
    
  }
 
</style>